import { useAdminLogoutMutation as e } from "../queries/admin/useAdminLogoutMutation.mjs";
//#region src/hooks/useAdminLogout.ts
var t = (t) => {
	let n = e();
	return {
		logout: async () => {
			await n.mutateAsync(void 0), t?.onLoggedOut?.();
		},
		isPending: n.isPending,
		error: n.error
	};
};
//#endregion
export { t as useAdminLogout };
